module.exports = __webpack_public_path__ + "a1e955fccb9e81e2ea2429988f575595.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-2.png
// module id = 1497
// module chunks = 0